import { gql } from '@apollo/client';

export const GET_BUY_MOTOR_POLICY_VAR_DETAILS = gql`
  query getBuyMotorPolicyDetails {
    buyMotorPolicy @client
  }
`;

export const SAVE_QUOTE_PCV = gql`
  mutation saveQuoteTW($input: TWQuoteInput) {
    saveQuoteTW(input: $input) {
      quoteNumber
      quoteCreationDate
      status
    }
  }
`;

export const SEND_POLICY_SMS = gql`
  mutation sendPolicySms(
    $input: ProposalInput
    $proposalNumber: String
    $mobile: String
    $policyNumber: String
    $alternateMobileNos: [String]
  ) {
    sendPolicySMS(
      input: $input
      proposalNumber: $proposalNumber
      mobile: $mobile
      policyNumber: $policyNumber
      alternateMobileNos: $alternateMobileNos
    ) {
      message
    }
  }
`;

export const SEND_POLICY_EMAIL = gql`
  mutation sendPolicyEmail(
    $input: ProposalInput
    $proposalNumber: String
    $email: String
    $policyNumber: String
    $ccEmailIds: [String]
  ) {
    sendPolicyEmail(
      input: $input
      proposalNumber: $proposalNumber
      email: $email
      policyNumber: $policyNumber
      ccEmailIds: $ccEmailIds
    ) {
      message
    }
  }
`;

export const SEND_POLICY_PDF = gql`
  mutation sendPolicyPDF(
    $input: ProposalInput
    $proposalNumber: String
    $policyNumber: String
  ) {
    sendPolicyPDF(
      input: $input
      proposalNumber: $proposalNumber
      policyNumber: $policyNumber
    ) {
      base64Pdf
    }
  }
`;

export const GET_CUSTOMER_TYPE_DOMAIN = gql`
  query getCustomerTypeDomain {
    customerTypeList {
      code
      value
    }
  }
`;

export const SEND_PROPOSAL_PDF = gql`
  mutation sendProposalPDFTW($input: TWProposalInput) {
    sendProposalPDFTW(input: $input) {
      base64Pdf
    }
  }
`;

export const BUY_POLICY = gql`
  mutation buyPolicy($input: PolicyInput) {
    issuePolicy(input: $input) {
      policyNo
      receiptID
      referenceNumber
      digiLink
      displayMessage
      additionalMessage
    }
  }
`;

export const QUERY_STATE = gql`
  query {
    quoteIntermediary @client
  }
`;

export const CUSTOMER_INDIVIDUAL_DROPDOWN_DETAIL = gql`
  query customerIndividualDetail {
    salutationList {
      code
      value
      gender
    }
    genderList {
      code
      value
    }
    maritalStatusList {
      code
      value
    }
    occupationList {
      code
      value
    }
    nomineeRelationshipList {
      code
      value
    }
    idProofTypeList {
      code
      value
    }
    nationalityList {
      code
      value
    }
  }
`;

export const GET_DATE_TIME = gql`
  query getDateTime {
    datetimeValue {
      time
      date
    }
  }
`;

export const PROPOSAL_PAYMENT_TYPE_LIST = gql`
  query proposalPaymentType {
    ProposalPaymentTypeList {
      code
      value
    }
  }
`;

export const CUSTOMER_ORGANISATIONAL_DROPDOWN_DETAIL = gql`
  query customerOrganisationDetails {
    organisationList {
      code
      value
    }
  }
`;

export const NOMINEE_DROPDOWN_DETAILS = gql`
  query nomineeDropDownDetails($productCode: StrictNumber) {
    PRD_NomiRelationWithMemb(productCode: $productCode) {
      code
      value
    }
    PRD_ApointRelationWithMinNomi(productCode: $productCode) {
      code
      value
    }
  }
`;

export const FINANCER_DROPDOWN_DETAILS = gql`
  query financerDetails($productCode: StrictNumber) {
    PRD_FinancerAgreementType(productCode: $productCode) {
      code
      value
    }
    PRD_IsYourVehicle(productCode: $productCode) {
      code
      value
    }
  }
`;

export const PREVIOUS_INSURER_COMPANY_LIST = gql`
  query prevCompanyList {
    rolloverCompanyList {
      code
      value
    }
  }
`;

export const LOB_PRODUCT_LIST = gql`
  query lobProductList {
    lobProductList {
      lob_name
      lob_code
      products {
        product_name
        product_code
        linkTo
      }
    }
  }
`;

export const FINANCIER_NAME_LIST = gql`
  query getFinancierNameList($value: String) {
    getFinancierNameList(value: $value) {
      code
      value
    }
  }
`;
export const CALCULATE_PREMIUM_FOR_PROPOSAL_TW = gql`
  query miscdcalculatePremiumProposal($input: PCVProposalInput) {
    miscdcalculatePremiumProposal(input: $input) {
      p_startdate
      idv1
      idv2
      idv3
      tenure
      netODPremium
      netTPPremium
      loadingDiscount
      netPremium
      gst
      stampDuty
      totalPremium
      loading {
        name
        amount
      }
      discount {
        name
        amount
      }
      vehicleAge
      claimFreeYear
      creditScore
      warningMsg
      NCB
    }
  }
`;
//SA975
export const CALCULATE_PREMIUM_FOR_PROPOSAL_TWAPI = gql`
  query calculatePremiumProposalTW($input: TWProposalInput) {
    calculatePremiumForProposalTWApi(input: $input) {
      baseod_premium
    basetppremium
    ncbamount
    ncbpercentage
    odpremium
    pacoveramount 
    paiddriverlegalliability 
    gst 
    premium 
    finalpremium 
    otherdiscount 
    addonprice 
    packageprice 
    transactionid 
    requestid
    idv 
    policy_start_date 
    policy_end_date 
    depreciation_prem 
    consumable_prem 
    engineprotect_prem 
    rti_prem 
    rsa_prem 
    ncb_protect_prem 
    key_replacement_prem 
    daily_car_allowance_prem 
    tyre_prem
    loss_of_pnbll_prem
    imt28_prem 
    pa_unnamed_premium 
    vddiscount_amt 
    garage_cash_prem 
    tppd_restriction_amt 
    commercial_private 
    net_tp_premiun 
    electrical_prem 
    non_electrical_prem 
    cng_od_prem
    cng_tp_prem
    trailer_od_prem 
    trailer_tp_prem 
    geo_od_prem
    geo_tp_prem 
    rally_od_prem 
    rally_tp_prem 
    addnl_owner_driver_prem 
    addnl_passenger_prem 
    addnl_towing_prem 
    hospital_prem 
    emergency_prem 
    emi_prem 
    courtesy_prem 
    pa_to_unnamed_prem 
    pa_to_named_prem 
    pa_to_paid_driver_prem 
    pa_to_no_of_soldier_prem 
    imt29_prem 
    softcopy_amount 
    fibre_glass_amount 
    anti_theft_amount 
    vintage_amount 
    imported_vehicle_amount 
    driving_tution_amount 
    vehicle_used_blind_amount 
    own_premices_amount 
    automobile_amount
    kotak_emp_amount 
    voluntary_ductible_dep_amount 
    fuel_nonconventional_dicount 
    imt18_premium 
    loss_of_access 
    campaign_code 
    basic_glm_rate 
    dep_glm_rate 
    consumable_glm_rate 
    rti_glm_rate 
    engprot_glm_rate 
    tyre_glm_rate 
    lop_glm_rate 
    daily_car_glm_rate 
    ncb_prot_glm_rate 
    adnl_od_glm_rate 
    adnl_pass_glm_rate 
    hospital_glm_rate
    emergency_glm_rate 
    emi_glm_rate 
    key_glm_rate 
    adnl_tow_glm_rate 
    garage_glm_rate 
    courtesy_glm_rate 
    switchcover_premium 
    switchdisc_rate 
    switchdisc_amt 
    idv2
    idv3
    vehicle_age
    system_idv
    errorcode
    success
    errormessage
    }
  }
`;
//EA975
export const SAVE_PROPOSAL_MISCD = gql`
  mutation MISCDsaveProposal($input: PCVProposalInput) {
    MISCDsaveProposal(input: $input) {
      proposalNumber
      proposalEndDate
      proposalStatus
      isApplicableForPayment
      VehicleInspectionNeeded
      premium {
        idv1
        idv2
        idv3
        tenure
        netODPremium
        netTPPremium
        loadingDiscount
        netPremium
        gst
        stampDuty
        totalPremium
        loading {
          name
          amount
        }
        discount {
          name
          amount
        }
        vehicleAge
        claimFreeYear
        creditScore
        NCB
      
      }
      customerID
      warningMsg
      Error
    }
  }
`;
export const DOCUMENT_STATIC_DATA = gql`
  query documentExtensions {
    documentListCarSecure {
      code
      value
    }
    documentExtensions {
      code
      value
    }
    docFileSizeLimit {
      code
      value
    }
    #docAddLimit {
    #code
    #value
    #}
    docDescCharacterLimit {
      code
      value
    }
  }
`;
export const GET_DOCUMENTS_INFO = gql`
  query documentsInfo($input: IDInput) {
    getDocumentsForCustomer(input: $input) {
      documentID
      documentName
      documentFileName
      documentExtension
      documentSize
      documentDescription
    }
    documentList(input: $input) {
      code
      value
    }
  }
`;
export const VIEW_DOCUMENT = gql`
  query viewDocument($input: ViewDocumentInput) {
    viewDocument(input: $input) {
      base64String
      documentExtension
      documentFileName
    }
  }
`;
export const UPLOAD_DOCUMENT = gql`
  mutation uploadDocument($input: UploadDocumentInput) {
    uploadDocuments(input: $input) {
      uploadStatus
      uploadStatusType
      documentDetails {
        documentID
        documentName
        documentFileName
        documentExtension
        documentSize
        documentDescription
      }
    }
  }
`;
export const GET_BUY_FIRE_UPLOAD_POLICY_VAR_DETAILS = gql`
  query getBuyFireUploadPolicyVarDetails {
    fireQuoteUploadDocs @client {
      documentDetails
    }
  }
`;
export const CHECK_IMD_CONFIG = gql`
  query checkConfigImd($intermediaryCode: String){
    checkConfigImd( intermediaryCode: $intermediaryCode){
      isConfiguredIMD
    }
  }
`;
export const FINANCER_DROPDOWN_DETAILS_MISCD = gql`
  query MISCDFinancierSearch($input: FinancierInput) {
    MISCDFinancierSearch(input: $input) {
      financier{
        bankCode
        bankName
      }
    }
  }
`;

export const PRODUCT_TYPE_LIST = gql`
  query productTypeList {
    lobProductList {
      lob_name
      lob_code
      products {
        product_name
        product_code
        product_types {
          code
          value
        }
        linkTo
        display_name
      }
    }
  }
`;
// export const CHECK_IMD_CONFIG = gql`
//   query checkConfigImd($intermediaryCode: String){
//     checkConfigImd( intermediaryCode: $intermediaryCode){
//       isConfiguredIMD
//     }
//   }
// `;
export const PROFILE_DETAILS = gql`
  query userMyDetail {
    userMyDetail {
      userId
      userType {
        typeName
      }
      profile {
        userImage
        firstName
        middleName
        lastName
        mobileNumber
        emailId
      }
      userCategory {
        categoryName
      }
      organisation {
        intermediaries {
          intermediaryName
          intermediaryCode
          isSelected
        }
      }
      status
    }
  }
`;
export const GET_IMD_ALLOW_LIMIT =gql`
  query IMD_Allowed_Limits{
    IMD_Allowed_Limits{
      IRF2_Allowed_IMD
    }
  }
`;